function MSAssignmentReportLoggerAnnotations() {
    /// <summary>
    /// This object provides js functions for the Widget.Membership.Assigment.* <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 11.5.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 11.5.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
  
}

MSAssignmentReportLoggerAnnotations.prototype = new window.MSAssignment();

MSAssignmentReportLoggerAnnotations.prototype.init = function () {
    var me = this;
    try {
        window.MSAssignment.prototype.init.call(me);
        me.visual.find('.vc-list').height(me.visual.height() -52);

        me.addspecificClickHandler();
        window._VCMQ.addConsumer(me.vcgid);
        window._VCMQ.consume(me.visual, me.vcgid, function (event) { me.doEvent(event); });

    } catch (ex) {
        me.writeError('MSAssignmentReportLoggerAnnotations.init', ex);

    }

};

MSAssignmentReportLoggerAnnotations.prototype.loadFirstInList = function () {
  
};

MSAssignmentReportLoggerAnnotations.prototype.loadItems = function(id) {
    var me = this;
    try {
        me.parameter = "";
        me.signalParameter = "";
        window.MSAssignment.prototype.loadItems.call(me, id);
        me.visual.find("#lstTarget").off("mouseenter ", ".btnOption").on("mouseenter ",
            ".btnOption",
            function() {

                //me.visual.find(".btnOption").removeClass("selected color-bg-secondary");
                $(this).removeClass("not-selected");

                $(this).addClass("color-bg-secondary selected");
            });
        me.visual.find("#lstTarget").off("mouseleave ", ".btnOption").on("mouseleave ",
            ".btnOption",
            function() {
                //me.visual.find(".btnOption").removeClass("not-selected");
                if ($(this).hasClass("selection-active") === false) {
                    $(this).removeClass("selected");

                    $(this).addClass("not-selected");
                }
            });
        //setTimeout(function () {
        //    me.visual.find("#lstTarget .vc-list-item[data-id='" + me.currentBlid + "']").addClass("color-bg-primary");
        //   
        //}, 100);
        //             me.visual.find("#lstTarget" #lstTarget .btnUsers").button();

    } catch (ex) {
        me.writeError('MSAssignmentReportLoggerAnnotations.loadItems', ex);
    }
};
MSAssignmentReportLoggerAnnotations.prototype.reportValid = function() {
    var me = this;
    try {
                 me.sendReportValidState(me.visual.find("#lstTarget").children().length > 0);
    } catch (ex) {
        me.writeError('MSAssignmentReportLoggerAnnotations.reportValid', ex);
    }

};

MSAssignmentReportLoggerAnnotations.prototype.manualUpdate = function (obj) {
    /// <summary>
    /// This function adds or deletes a single entry which is moved between the two connected lists.
    /// </summary>
    var me = this;

    try {
        var source = obj.parents(".connect").attr("id");
        var target = "";
        if (source === "lstSource") {
            target = "lstTarget";
        }
        if (source === "lstTarget") {
            //stop if the item cannot get deleted
            if (obj.hasClass("notDelete")) {
                me.showMessage(me.resources.entryCannotGetDeleted, false);
                return false;
            }
            target = "lstSource";
        }
        me.showInfo("", "", false);
    if (source.localeCompare("lstTarget") === 0) {
            me.openAskDialog(me.resources.deleteConfirmText,
                { at: 'center center-20%', of: window },
                function () {
                    if (typeof (obj[0].attributes["data-id"]) !== "undefined") {
                        me.updateConfirmed(obj, obj.parents(".connect").attr("id"), obj[0].attributes["data-id"].value, target);
                    }
                });
        } else {
            if (typeof (obj[0].attributes["data-id"]) !== "undefined") {

                me.updateConfirmed(obj, obj.parents(".connect").attr("id"), obj[0].attributes["data-id"].value, target);
            }
        }
        return true;
    } catch (ex) {
        me.writeError('manualUpdate', ex);
        return false;
    }

};

MSAssignmentReportLoggerAnnotations.prototype.sendReportValidState = function(valid) {
    var me = this;
    try {       
        window._VCMQ.produce(me.visual, me.vcgid, "REP_CONFIG_VALID", { "valid": valid, "step": 2 });

    } catch (ex) {
        me.writeError('MSAssignmentReportLoggerAnnotations.sendReportValidState', ex);

    }
};
MSAssignmentReportLoggerAnnotations.prototype.updateConfirmed = function (obj, source, id, target) {
    var me = this;
    if (window.MSAssignment.prototype.update.call(me, source, id)) {
        me.sendReportValidState(source.localeCompare("lstSource") === 0 ||
            (source.localeCompare("lstTarget") === 0 && me.visual.find("#lstTarget").children().length > 0));
    } else {
        me.sendReportValidState(false);
    }
    var litem = obj.clone();
    litem.appendTo(me.visual.find("#" + target));
    obj.remove();
    setTimeout(function () { $(".vc-wizard-step.active").trigger("click"); }, 30);

}
MSAssignmentReportLoggerAnnotations.prototype.doEvent = function(event) {
    var me = this;
    try {
        if (event.msg === "ANNOTATION_COUNT_CHANGED" || event.msg === "USER_COUNT_CHANGED") {
            if (event.msg === "ANNOTATION_COUNT_CHANGED") {
                me.visual.find("#lstTarget .vc-list-item[data-id=" + me.currentBlid + "] .btnAnnot")
                    .addClass("color-bg-secondary selected").removeClass("not-selected");
            } else if (event.msg === "USER_COUNT_CHANGED") {
                //alert("test");
                me.visual.find("#lstTarget .vc-list-item[data-id=" + me.currentBlid + "] .btnUsers").trigger("click");
                //.addClass("color-bg-secondary selected").removeClass("not-selected");
            }
           
            me.loadItems(me.assID);
        }
       
    } catch (ex) {
        me.writeError('MSAssignmentReportLoggerAnnotations.doEvent', ex);
    }
};

MSAssignmentReportLoggerAnnotations.prototype.addspecificClickHandler = function () {
    /// <summary>
    /// This function inits the assigment specific click handler if implemented
    /// </summary>
    ///<param name='row'> a row object to add the item </param>
    var me = this;
    try {
        if (me.error) { return false; }
        var width;
        if (me.visual.find("#lstTarget").css("width") === "348px") {
            width = 365;
        } else {
            width = 465;
        }
            //me.visual.find("#lstTarget .btnAnnot, #lstTarget .btnUsers");
            me.visual.find("#lstTarget").off("click, .btnAnnot").on("click", ".btnAnnot",
                function (event) {
                    var projectName = $(this).data("name");

                    event.stopPropagation();
                    me.visual.find(".vc-list-item").removeClass("color-bg-primary");
                    $(this).parents(".vc-list-item").addClass("color-bg-primary");
                    //me.currentBlid = $(this).parents(".vc-list-item").data("id");
                    me.visual.find(".btnOption").removeClass("color-bg-secondary selected selection-active");
                    me.visual.find(".btnOption").not(this).addClass("not-selected");
                    $(this).addClass("color-bg-secondary selected selection-active");
                                     $(this).parents(".vc-list-item").trigger("click");

                    window.VisualCoreService.getVisualContentByName("FORM_REPORT_ANNOTATIONS","divFormEdit",'27.11.2015',380,380,JSON.stringify({ "rrid": me.assID, "loggerid": $(this).data("id") }),"",1,function (result) {
                            $("#project-settings #project-settings-name").html(projectName).css({ "margin-left": 0 });
                            $("#user-assign").html(result);
                        $("#user-assign").html(result);
                    });
                });
            
            me.visual.find("#lstTarget").off("click", ".btnUsers").on("click", ".btnUsers", function (event) {
                var projectName = $(this).data("name");

                event.stopPropagation();
                me.visual.find(".vc-list-item").removeClass("color-bg-primary");
                $(this).parents(".vc-list-item").addClass("color-bg-primary");
                me.currentBlid = $(this).parents(".vc-list-item").data("id");
                 $(this).parents(".vc-list-item").trigger("click");
                    me.visual.find(".btnOption").removeClass("color-bg-secondary selected selection-active");
                    me.visual.find(".btnOption").not(this).addClass("not-selected");
                    $(this).addClass("color-bg-secondary selected selection-active");
                window.VisualCoreService.getVisualContentByName(
                    "WIDGET_ASSIGNMENT_REPORT_LOGGER_USER", "users", '27.11.2015',me.visual.find("#divTarget").outerHeight(),width,JSON.stringify({ "id": me.assID, "AssId": $(this).data("assid") }),"",1,
                        function (result) {
                            $("#project-settings #project-settings-name").html(projectName).css({ "margin-left": "0" });
                            $("#user-assign").html(result);
                        });
                });
        
    
    } catch (ex) {
        me.writeError('MSAssignmentReportLoggerAnnotations.addspecificClickHandler', ex);
        return false;
    }
    return true;
};

MSAssignmentReportLoggerAnnotations.prototype.addAssignmentItemSpecifics = function (row) {
    /// <summary>
    /// This function inits the assigment specific icons if implemented
    /// </summary>
    ///<param name='row'> a row object to add the item </param>
    var me = this;
    var sTmp = "";
    try {
        if (me.error) { return false; }
        //sTmp += "<div class='uedit button-toggle'data-id='" + row.id + "' data-name='" + row.prefix + " - " + row.name + "'><span class='annot'>"+ row.annocount + "</span> " + me.resources.annotations + "</div>";
      
        sTmp +=
            "<div title='"+me.resources.user+"'" +
            " data-assid='"+row.assid+"'" +
            " data-id='" + row.id + "'" +
            " data-name='" + row.prefix + " - " + row.name + "' " +
            "class='btnUsers btnOption not-selected'>" +
          "<span id='us-count'>"+row.usercount+"</span> <i class='fa fa-users icon-button-type'></i></div>";
       // 
        sTmp +=
            "<div title='" + me.resources.annotations +"'" +
            "data-id='" + row.id + "' " +
            "data-name='" + row.prefix + " - " + row.name + "'  " +
            "class='btnAnnot btnOption not-selected'" +
            " >" +
            "<span id='annot-count'>" + row.annocount +"</span> <i class='fa fa-comments icon-button-type'></i></div>";
        //
        return sTmp;
    } catch (ex) {
        me.writeError('MSAssignmentReportLoggerAnnotations.addAssignmentmentItemSpecifics', ex);
        return false;
    }
};


